import { agenciesConstants } from '../../constants/agencies';
import { history } from '../../routes/AppRouter';

export const redirectToAgenciesData = () => next => action => {
  if (action.type === agenciesConstants.SET_REDIRECT_TO_AGENCIES_DATA) {
    if (action.agencyId) {
      history.push('/tools/bonuses');
    }
  }

  return next(action);
};
